import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';
import LoadingSpinner from '../components/widgets/LoadingSpinner';

const PermissionRoute = ({ permission, redirectTo = "/app/dashboard" }) => {
  const authState = useSelector((state) => state.auth);

  if (authState.loading || authState.loadingUser) {
    return <LoadingSpinner />;
  }

  if (!authState.isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  if (!authState.user) {
    return <LoadingSpinner />;
  }

  const isUnionAdmin = authState.user?.roles?.includes('UNION_ADMIN');
  const hasPermission = Boolean(authState.user?.[permission]);
  if (!hasPermission && !isUnionAdmin) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};

export default PermissionRoute;
